import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import Input from '../components/Input';
import Button from '../components/Button';
// import Loader from '../components/Loader';
import api from '../services/api';

const instancia = process.env.REACT_APP_INSTANCIA;

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
`;

const LoginCard = styled(motion.div)`
  background: white;
  border-radius: 24px;
  padding: 40px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
`;

const LoginHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

const Title = styled.h1`
  color: #333;
  font-size: 28px;
  margin-bottom: 12px;
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 16px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const ForgotPassword = styled.a`
  color: #6c5ce7;
  font-size: 14px;
  font-weight: 500;
  align-self: flex-end;
  margin-bottom: 24px;
  transition: opacity 0.3s;
  
  &:hover {
    opacity: 0.8;
  }
`;

const ErrorMessage = styled(motion.div)`
  background-color: #ffecec;
  color: #e74c3c;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 8px;
  }
`;

// Animações
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1
        }
    }
};

const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: 'spring',
            stiffness: 100
        }
    }
};

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            setError('Por favor, preencha todos os campos');
            return;
        }

        try {
            setIsLoading(true);
            setError('');

            // Envio dos dados para o endpoint de login
            const response = await api.post('/usuarios/login', {
                email,
                senha: password,
                instancia: `${instancia}`
            });

            // Armazenar o token recebido
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('codigoUsuarioLogado', response.data.cod_usuario);
            localStorage.setItem('nomeUsuarioLogado', response.data.nome);
            localStorage.setItem('iniciaisUsuarioLogado', response.data.nome.substring(0, 1).toUpperCase());
            localStorage.setItem('emailUsuarioLogado', response.data.email);

            // Navegar para a página inicial após o login bem-sucedido
            navigate('/home');
        } catch (err) {
            console.error('Erro ao fazer login:', err);

            // Tratar erros da API
            if (err.response) {
                setError(err.response.data.message || 'Credenciais inválidas. Verifique seu email e senha.');
            } else {
                setError('Erro ao conectar com o servidor. Tente novamente mais tarde.');
            }

            setIsLoading(false);
        }
    };

    return (
        <LoginContainer>
            <LoginCard
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <LoginHeader>
                    <Title>Bem-vindo(a) de volta!</Title>
                    <Subtitle>Faça login para acessar sua conta</Subtitle>
                </LoginHeader>

                <Form onSubmit={handleSubmit} as={motion.form} variants={containerVariants} initial="hidden" animate="visible">
                    {error && (
                        <ErrorMessage
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0 }}
                        >
                            {error}
                        </ErrorMessage>
                    )}

                    <motion.div variants={itemVariants}>
                        <Input
                            label="Email"
                            name="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </motion.div>

                    <motion.div variants={itemVariants}>
                        <Input
                            label="Senha"
                            name="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </motion.div>

                    <motion.div variants={itemVariants}>
                        <ForgotPassword href="#">Esqueceu sua senha?</ForgotPassword>
                    </motion.div>

                    <motion.div variants={itemVariants}>
                        <Button
                            type="submit"
                            isLoading={isLoading}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Entrando...' : 'Entrar'}
                        </Button>
                    </motion.div>
                </Form>
            </LoginCard>
        </LoginContainer>
    );
};

export default Login;